import { useInputCreditCardProps } from '../../hooks'
import * as Comp from './input-credit-card-label.styles'

export const InputCreditCardLabel = ({
  children,
}: { children: React.ReactNode }) => {
  const { disabled, readonly, size } = useInputCreditCardProps()
  return (
    <Comp.Label
      numberOfLines={1}
      disabled={disabled}
      readonly={readonly}
      size={size}
    >
      {children}
    </Comp.Label>
  )
}
